//export const server = "http://localhost:5000/"
export const server = "https://itleti-back.herokuapp.com/"

